"use client";

import { Button } from "@/components/ui/button";
import { navItems } from "@/config/nav-items";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { Sheet, SheetTrigger } from "./ui/sheet";
import MobileNavbar from "./ui/mobile-navbar";
import { AlignJustify } from "lucide-react";
import { RiTelegram2Line } from "react-icons/ri";
import { BsTwitterX } from "react-icons/bs";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export function NavBar({ ClassName }: { ClassName?: string }) {
  const pathname = usePathname();
  const [isScrolled, setIsScrolled] = useState(false);

  // Check scroll position only when on /vote
  useEffect(() => {
    const handleScroll = () => {
      if (pathname === "/vote") {
        setIsScrolled(window.scrollY > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    // Call immediately in case the page is already scrolled
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  const isSpecialRoute = pathname === "/vote" || pathname === "/docs";
  const bgClass = isSpecialRoute
    ? isScrolled
      ? "bg-indigo-500/80 text-white"
      : "bg-transparent text-white"
    : "bg-bg-200 text-text-100";

  return (
    <div
      className={cn(
        "flex flex-col w-full justify-center sticky md:fixed top-0 md:py-0.5 z-30",
        bgClass
      )}
    >
      <nav
        className={cn(
          "md:flex items-center hidden bg-transparent transition-all justify-center gap-0 lg:gap-6 px-4 py-2.5 relative z-10 backdrop-blur-sm",
          ClassName
        )}
      >
        <>
          <Link
            href="/"
            className="text-lime-300 text-2xl inline-flex w-auto font-bold"
          >
            <Image
              src="/logo.png"
              alt="CatDevAI logo"
              className=" inline-flex"
              width={180}
              height={50}
              // className="w-[30%]"
            />
          </Link>
          <div className="flex items-center gap-4 mx-2 lg:mx-4">
          {navItems.map((item) => {
            const isActive = pathname === item.href;
            return (
              <Link key={item.label} href={item.href}>
                <Button
                  variant="link"
                  className={cn(
                    "text-current bg-transparent font-rubik text-base  font-normal",
                    isActive ? (isSpecialRoute ? "text-lime-300" : "text-primary-100") : "" 
                  )}
                >
                  {item.label === "Buy" && (
                    <Image
                      src="/assests/pump_buy_logo.png"
                      alt="Pump"
                      width={100}
                      height={100}
                      className="w-6 h-6"
                    />
                  )}
                  {item.label}
                </Button>
              </Link>
            );
          })}
          </div>

          <div className="flex items-center gap-1 bg-gradient-to-r from-primary-default to-primary-100 rounded-full px-1 lg:px-2">
            <Link
              href={"https://x.com/CatDevAi"}
              className="items-center"
              target="_blank"
            >
              <button className="text-white hover:text-white px-4 py-2 rounded-lg bg-transparent ">
                <BsTwitterX className="w-5 h-5" />
              </button>
            </Link>
            <Link
              href={"https://t.me/CatDevAi"}
              className="items-center"
              target="_blank"
            >
              <button className="text-white hover:text-white px-3 py-1.5 rounded-lg bg-transparent ">
                <RiTelegram2Line className="w-7 h-7" />
              </button>
            </Link>
          </div>
        </>
      </nav>

      
      <div className="h-0.5 z-10 w-full absolute bottom-0 bg-[linear-gradient(to_right,transparent_20%,var(--primary-100)_50%,transparent_80%)]"/>
      {/* mobile screens */}
      <div className="z-10 flex p-4 fixed top-0 left-0 justify-between items-center md:hidden bg-bg-200 w-full backdrop-blur-sm">
        <Link
          href="/"
          className="text-lime-300 text-2xl inline-flex w-auto font-bold"
        >
          <Image
            src="/logo.png"
            alt="CatDevAI logo"
            className=" inline-flex w-[70%]"
            width={180}
            height={50}
            // className="w-[30%]"
          />
        </Link>

        <Sheet>
          <SheetTrigger className="md:hidden">
            <AlignJustify
              className="text-white active:text-neutral-300"
              size={30}
            />
          </SheetTrigger>
          <MobileNavbar />
        </Sheet>
      </div>
      
    </div>
  );
}
